import {
	getVariantPrice,
	moneyToNumber,
	numberToMoney,
} from "@babybjorn/utils/commercetools/money";
import type {
	Cart,
	ProductVariant,
	TypedMoney,
} from "@commercetools/platform-sdk";
import { taxIsIncludedInPrice } from "./helpers";

const formatCurrency = (currency: string, value: string): string => {
	switch (currency) {
		case "CAD": {
			return value.replace("$", "C$");
		}
		default: {
			return value;
		}
	}
};

export const formatPrice = (currency: string, value: number): string => {
	const locale = process.env.GATSBY_LANGUAGE;
	if (!locale) throw new Error("Language not set");

	const formattedValue = new Intl.NumberFormat(locale, {
		style: "currency",
		currency,
		trailingZeroDisplay: "stripIfInteger",
	}).format(value);

	return formatCurrency(currency, formattedValue);
};

export const formatMoney = (money: TypedMoney): string =>
	formatPrice(money.currencyCode, moneyToNumber(money));

export const formatVariantPrice = (
	variant: Queries.ProductVariantFragment | ProductVariant,
	currency: string,
	country: string | undefined,
): string => {
	const variantPrice = getVariantPrice(variant, currency, country);

	return formatMoney(variantPrice);
};

export const formatSubtotalPrice = (cart: Cart): string => {
	const shippingNet = moneyToNumber(cart.shippingInfo?.taxedPrice?.totalNet);

	const totalNet = moneyToNumber(cart.taxedPrice?.totalNet ?? cart.totalPrice);

	const totalPrice = moneyToNumber(cart.totalPrice);

	const shippingCost = moneyToNumber(cart.shippingInfo?.price);

	const subtotalTaxIncluded = Math.max(0, totalPrice - shippingCost);

	const subtotal = Math.max(0, totalNet - shippingNet);

	return formatMoney(
		numberToMoney(
			taxIsIncludedInPrice(cart) ? subtotalTaxIncluded : subtotal,
			cart.totalPrice.currencyCode,
			cart.totalPrice.fractionDigits,
		),
	);
};
